import "./RemoveTodoList.scss";
import { useTranslation, Trans } from "react-i18next";

function RemoveTodoList({
  cancelRemoveTodoList,
  removeTodoList,
  todoListTitle,
  itemCount = 0,
}) {
  const { t } = useTranslation();
  return (
    <div className="remove-todolist-content">
      <div className="modal-title">
        <div>{t("lists.modals.removeList.title")}</div>
      </div>
      <div className="modal-body">
        <p>{t("lists.modals.deleteConfirm", { name: todoListTitle })}</p>
        <p className="remove-warning">
          {itemCount > 0 ? (
            <Trans
              i18nKey="lists.modals.removeList.warningItems"
              count={itemCount}
              components={{ bold: <strong /> }}
            />
          ) : (
            t("lists.modals.removeList.warningEmpty")
          )}
        </p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={cancelRemoveTodoList}>
          {t("common.cancel")}
        </button>
        <button className="modal-button delete" onClick={removeTodoList}>
          {t("common.remove")}
        </button>
      </div>
    </div>
  );
}

export default RemoveTodoList;
